import branch from 'branch-sdk'
import mixpanel from 'mixpanel-browser'
import { type TrackingEventName, PLATFORM, TRACKING_TYPES } from '@/constants/TrackingConstants'
import { type AttributionEnvelope, attributionEventProperties, flattenAttribution } from '@/config/attribution'

const fbq = (window as any).fbq

export const eventRegisterClick = () => fbq('track', 'TakiaEventRegisterClick')

export const signupRegisterClick = () => fbq('track', 'New Signup')

export const eventRegisterCompleteClick = () => fbq('track', 'TakiaEventRegistrationComplete')

export const branchTrackRegistration = (email: string, method: string) =>
  branch.logEvent(
    'COMPLETE_REGISTRATION',
    {
      User_Email: email,
      Method: method,
    },
    undefined,
    undefined
  )

export const identifyUser = (userId: any) => mixpanel.identify(userId)

export const setUserDetails = (userDetails: any) => mixpanel.people.set(userDetails)

/** Every Mixpanel event: the campaign that brought this visitor (if any, inside the window) plus the caller's properties. */
export const eventTracker = (eventName: TrackingEventName, properties?: object) => {
  mixpanel.track(eventName, { ...attributionEventProperties(), ...properties, platform: PLATFORM })
}

/**
 * The funnel's first step, shared with the mobile app: a tagged link was opened. The envelope is
 * passed explicitly rather than read back from storage so the event is right even where storage
 * is unavailable.
 */
export const trackCampaignLinkOpened = (envelope: AttributionEnvelope) =>
  eventTracker(TRACKING_TYPES.CAMPAIGN_LINK_OPENED, { entry: 'url', ...flattenAttribution(envelope) })

/** Which checkout completed the purchase. The mobile app sends its own value for the same event. */
export type PurchaseFlow = 'dashboard' | 'partner' | 'partner_stripe' | 'redeem'

export interface PurchaseCompletedProperties {
  purchase_flow: PurchaseFlow
  product_id?: string
  partner_id?: string
  promotion_id?: string
  stripe_session_id?: string
}

/**
 * The one purchase event shared with the mobile app. Fires once per completed purchase, beside
 * the legacy payment events, and carries the campaign that brought the buyer via `eventTracker`.
 */
export const trackPurchaseCompleted = (properties: PurchaseCompletedProperties) =>
  eventTracker(TRACKING_TYPES.PURCHASE_COMPLETED, properties)
